module.exports = __webpack_public_path__ + "images/icons/logos/global-black-1f53a1ce.svg";